export const JV_STORES = {
  AD: 'AD',
  IB: 'IB',
  CN: 'CN'
}